// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progress-remaining-points .ant-progress-bg {
  height: var(--spacing-regular) !important;
  background: #25CC6E;
}
.progress-remaining-points-finished .ant-progress-inner {
  background-color: #EEEAEC;
}
.progress-remaining-points-finished .ant-progress-bg {
  height: var(--spacing-regular) !important;
  background: #F74710;
}
.container-title-main {
  padding-top: var(--spacing-regular);
}
.manage-points-text-title {
  color: var(--color-neutral-dark-darker);
}
.manage-points-details-main {
  font-size: var(--font-big);
  color: var(--color-neutral-dark-darker);
}
.manage-points-details-sub {
  font-size: var(--font-medium);
  font-weight: 500;
}
.table-focal-point .ant-table-cell {
  padding: var(--spacing-regular) var(--spacing-regular);
}
.table-focal-point .ant-table-expanded-row {
  background-color: #FFF;
}
.table-focal-point .ant-table-expanded-row .ant-table-cell {
  background-color: #FFF;
}
.table-focal-point .ant-table-expanded-row:hover .ant-table-cell {
  background-color: #FFF;
}
.table-focal-point .ant-table-content {
  overflow-y: auto;
}
.table-focal-point table {
  min-width: 1400px;
}
.button-focal-point.vert-button:not([disabled]).ant-btn-highlight {
  background-color: var(--color-highlight) !important;
}
.button-focal-point.vert-button:not([disabled]).ant-btn-highlight:hover {
  background-color: var(--color-highlight-darker) !important;
}
.button-focal-point.vert-button:not([disabled]).ant-btn-default {
  border-color: var(--color-highlight) !important;
  color: var(--color-highlight) !important;
}
.button-focal-point.vert-button:not([disabled]).ant-btn-default:hover {
  border-color: var(--color-border) !important;
}
.button-focal-point {
  padding: 0px var(--spacing-small) !important;
}
.button-focal-point-edit {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.button-focal-point-cancel {
  width: 100%;
}
.button-focal-point-cancel-container-span {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.button-focal-point-span {
  margin-left: var(--spacing-small);
}
.container-back-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: end;
}
.back-button-span {
  margin-left: var(--spacing-regular);
  color: var(--color-highlight);
}
.container-message-allocate-points {
  display: flex;
  flex-direction: row;
  justify-content: start;
}
.message-allocate-points-chip {
  padding: var(--spacing-extra-small) var(--spacing-regular);
  background-color: hsl(from var(--color-highlight-lighter) h s l / 0.3);
  border-radius: 50px;
  text-align: center;
}
.message-allocate-points-expired-chip {
  padding: var(--spacing-extra-small) var(--spacing-regular);
  background-color: hsl(from var(--color-error) h s l / 0.3);
  border-radius: 50px;
  text-align: center;
}
.message-cannot-allocate-points-chip {
  padding: var(--spacing-extra-small) var(--spacing-regular);
  background-color: #EEEAEC;
  border-radius: 50px;
  text-align: center;
}
.container-button-csv a {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.message-allocate-points-chip-span {
  color: var(--color-highlight-lighter);
  filter: brightness(0.6);
}
.message-allocate-points-expired-chip-span {
  color: var(--color-error);
  filter: brightness(0.6);
}
.message-cannot-allocate-points-chip-span {
  color: var(--color-neutral-dark-lighter);
}
.container-warning-need-allocate {
  margin-top: var(--spacing-regular);
}
.warning-need-allocate-text {
  color: var(--color-neutral-dark-lighter);
  font-size: var(--font-medium);
  font-weight: 500;
}
.container-allocate-points-progress {
  display: flex;
  flex-direction: column;
  align-items: end;
}
.allocate-points-progress-span {
  margin-top: var(--spacing-small);
  font-size: var(--font-medium);
  color: var(--color-text-input-disabled);
  font-weight: 500;
}
.container-table-allocate-points-participant {
  margin-top: var(--spacing-regular);
}
.container-modal-focal-point-manage .ant-modal-content {
  padding: var(--spacing-extra-big) !important;
}
.container-modal-focal-point-manage .ant-modal-title {
  position: absolute;
  top: var(--spacing-regular);
}
.container-loading-upload-excel {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: var(--color-neutral-dark-lighter);
  z-index: 999;
  opacity: 0.7;
}
.icon-summary-upload-distribution {
  width: 36px;
  height: 36px;
}
.icon-summary-upload-distribution span {
  width: 100% !important;
  height: 100% !important;
}
.icon-summary-upload-distribution span svg {
  fill: var(--success-color) !important;
  width: 100% !important;
  height: 100% !important;
}
.mt-16 {
  margin-top: 16px;
}
.modal-upload-divider {
  width: 100%;
  border-bottom-color: var(--color-neutral-dark-lighter);
  border-bottom-style: solid;
  border-bottom-width: 1px;
}
.icon-share-summary-upload-distribution span svg {
  fill: var(--color-highlight) !important;
}
.icon-download-excel-model svg {
  fill: white !important;
}
.form-add-participant .vert-form-item {
  margin-bottom: 0px;
}
.modal-allocate-point-text-main {
  font-size: var(--font-medium);
  color: var(--color-neutral-dark-darker);
  font-weight: 600;
}
.modal-allocate-point-text-sub {
  font-size: var(--font-medium);
  color: var(--color-neutral-dark-lighter);
  font-weight: 500;
}
.modal-allocate-success-text-main {
  font-size: var(--font-big);
  color: var(--color-neutral-dark-darker);
  font-weight: 600;
}
.modal-allocate-success-text-sub {
  font-size: var(--font-medium);
  color: var(--color-neutral-dark);
  font-weight: 400;
}
.modal-allocate-success-container-button {
  padding: var(--spacing-small);
}
.container-modal-excel {
  margin-top: var(--spacing-extra-big);
}
.modal-excel-select-text {
  font-size: var(--font-medium);
  color: var(--color-neutral-dark);
  font-weight: 400;
}
.modal-remove-participant-text {
  font-size: var(--font-big);
  color: var(--color-neutral-dark-darker);
  font-weight: 600;
}
.modal-remove-participant-container-button {
  margin-top: var(--font-medium);
}
.width-100 {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/pages/focalPoint/FocalPointManagePointsStyles.less"],"names":[],"mappings":"AACA;EAEQ,yCAAA;EACA,mBAAA;AADR;AAKA;EAEQ,yBAAA;AAJR;AAEA;EAMQ,yCAAA;EACA,mBAAA;AALR;AASA;EACI,mCAAA;AAPJ;AAUA;EACI,uCAAA;AARJ;AAWA;EACI,0BAAA;EACA,uCAAA;AATJ;AAYA;EACI,6BAAA;EACA,gBAAA;AAVJ;AAaA;EAGQ,sDAAA;AAbR;AAUA;EAOQ,sBAAA;AAdR;AAOA;EAUY,sBAAA;AAdZ;AAIA;EAgBY,sBAAA;AAjBZ;AACA;EAqBQ,gBAAA;AAnBR;AAFA;EAyBQ,iBAAA;AApBR;AAyBA;EACI,mDAAA;AAvBJ;AA0BA;EACI,0DAAA;AAxBJ;AA2BA;EACI,+CAAA;EACA,wCAAA;AAzBJ;AA4BA;EACI,4CAAA;AA1BJ;AA6BA;EACI,4CAAA;AA3BJ;AA8BA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AA5BJ;AA+BA;EACI,WAAA;AA7BJ;AAgCA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AA9BJ;AAiCA;EACI,iCAAA;AA/BJ;AAkCA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;AAhCJ;AAmCA;EACI,mCAAA;EACA,6BAAA;AAjCJ;AAoCA;EACI,aAAA;EACA,mBAAA;EACA,sBAAA;AAlCJ;AAqCA;EACI,0DAAA;EACA,sEAAA;EACA,mBAAA;EACA,kBAAA;AAnCJ;AAsCA;EACI,0DAAA;EACA,0DAAA;EACA,mBAAA;EACA,kBAAA;AApCJ;AAuCA;EACI,0DAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AArCJ;AAwCA;EAEQ,aAAA;EACA,mBAAA;EACA,uBAAA;AAvCR;AA2CA;EACI,qCAAA;EACA,uBAAA;AAzCJ;AA4CA;EACI,yBAAA;EACA,uBAAA;AA1CJ;AA6CA;EACI,wCAAA;AA3CJ;AA8CA;EACI,kCAAA;AA5CJ;AA+CA;EACI,wCAAA;EACA,6BAAA;EACA,gBAAA;AA7CJ;AAgDA;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;AA9CJ;AAiDA;EACI,gCAAA;EACA,6BAAA;EACA,uCAAA;EACA,gBAAA;AA/CJ;AAkDA;EACI,kCAAA;AAhDJ;AAmDA;EAEQ,4CAAA;AAlDR;AAgDA;EAMQ,kBAAA;EACA,2BAAA;AAnDR;AAuDA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,6CAAA;EACA,YAAA;EACA,YAAA;AArDJ;AAwDA;EACI,WAAA;EACA,YAAA;AAtDJ;AAoDA;EAKQ,sBAAA;EACA,uBAAA;AAtDR;AAgDA;EASY,qCAAA;EACA,sBAAA;EACA,uBAAA;AAtDZ;AA2DA;EACI,gBAAA;AAzDJ;AA4DA;EACI,WAAA;EACA,sDAAA;EACA,0BAAA;EACA,wBAAA;AA1DJ;AA6DA;EAGY,uCAAA;AA7DZ;AAkEA;EAEQ,sBAAA;AAjER;AAqEA;EAEQ,kBAAA;AApER;AAwEA;EACI,6BAAA;EACA,uCAAA;EACA,gBAAA;AAtEJ;AAyEA;EACI,6BAAA;EACA,wCAAA;EACA,gBAAA;AAvEJ;AA0EA;EACI,0BAAA;EACA,uCAAA;EACA,gBAAA;AAxEJ;AA2EA;EACI,6BAAA;EACA,gCAAA;EACA,gBAAA;AAzEJ;AA4EA;EACI,6BAAA;AA1EJ;AA6EA;EACI,oCAAA;AA3EJ;AA8EA;EACI,6BAAA;EACA,gCAAA;EACA,gBAAA;AA5EJ;AA+EA;EACI,0BAAA;EACA,uCAAA;EACA,gBAAA;AA7EJ;AAgFA;EACI,8BAAA;AA9EJ;AAiFA;EACI,WAAA;AA/EJ","sourcesContent":["//DESKTOP\n.progress-remaining-points {\n    .ant-progress-bg {\n        height: var(--spacing-regular) !important;\n        background: #25CC6E;\n    }\n}\n\n.progress-remaining-points-finished {\n    .ant-progress-inner {\n        background-color: #EEEAEC;\n    }\n\n    .ant-progress-bg {\n        height: var(--spacing-regular) !important;\n        background: #F74710;\n    }\n}\n\n.container-title-main {\n    padding-top: var(--spacing-regular);\n}\n\n.manage-points-text-title {\n    color: var(--color-neutral-dark-darker);\n}\n\n.manage-points-details-main {\n    font-size: var(--font-big);\n    color: var(--color-neutral-dark-darker);\n}\n\n.manage-points-details-sub {\n    font-size: var(--font-medium);\n    font-weight: 500;\n}\n\n.table-focal-point {\n\n    .ant-table-cell {\n        padding: var(--spacing-regular) var(--spacing-regular);\n    }\n\n    .ant-table-expanded-row {\n        background-color: #FFF;\n\n        .ant-table-cell {\n            background-color: #FFF;\n        }\n    }\n\n    .ant-table-expanded-row:hover {\n        .ant-table-cell {\n            background-color: #FFF;\n        }\n    }\n\n    .ant-table-content {\n        overflow-y: auto;\n    }\n\n    table {\n        min-width: 1400px;\n    }\n}\n\n//Button\n.button-focal-point.vert-button:not([disabled]).ant-btn-highlight {\n    background-color: var(--color-highlight) !important;\n}\n\n.button-focal-point.vert-button:not([disabled]).ant-btn-highlight:hover {\n    background-color: var(--color-highlight-darker) !important;\n}\n\n.button-focal-point.vert-button:not([disabled]).ant-btn-default {\n    border-color: var(--color-highlight) !important;\n    color: var(--color-highlight) !important;\n}\n\n.button-focal-point.vert-button:not([disabled]).ant-btn-default:hover {\n    border-color: var(--color-border) !important;\n}\n\n.button-focal-point {\n    padding: 0px var(--spacing-small) !important;\n}\n\n.button-focal-point-edit {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n}\n\n.button-focal-point-cancel {\n    width: 100%;\n}\n\n.button-focal-point-cancel-container-span {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n}\n\n.button-focal-point-span {\n    margin-left: var(--spacing-small);\n}\n\n.container-back-button {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: end;\n}\n\n.back-button-span {\n    margin-left: var(--spacing-regular);\n    color: var(--color-highlight);\n}\n\n.container-message-allocate-points {\n    display: flex;\n    flex-direction: row;\n    justify-content: start;\n}\n\n.message-allocate-points-chip {\n    padding: var(--spacing-extra-small) var(--spacing-regular);\n    background-color: hsl(from var(--color-highlight-lighter) h s l / 0.3);\n    border-radius: 50px;\n    text-align: center;\n}\n\n.message-allocate-points-expired-chip {\n    padding: var(--spacing-extra-small) var(--spacing-regular);\n    background-color: hsl(from var(--color-error) h s l / 0.3);\n    border-radius: 50px;\n    text-align: center;\n}\n\n.message-cannot-allocate-points-chip {\n    padding: var(--spacing-extra-small) var(--spacing-regular);\n    background-color: #EEEAEC;\n    border-radius: 50px;\n    text-align: center;\n}\n\n.container-button-csv {\n    a {\n        display: flex;\n        flex-direction: row;\n        justify-content: center;\n    }\n}\n\n.message-allocate-points-chip-span {\n    color: var(--color-highlight-lighter);\n    filter: brightness(0.6);\n}\n\n.message-allocate-points-expired-chip-span {\n    color: var(--color-error);\n    filter: brightness(0.6);\n}\n\n.message-cannot-allocate-points-chip-span {\n    color: var(--color-neutral-dark-lighter);\n}\n\n.container-warning-need-allocate {\n    margin-top: var(--spacing-regular);\n}\n\n.warning-need-allocate-text {\n    color: var(--color-neutral-dark-lighter);\n    font-size: var(--font-medium);\n    font-weight: 500;\n}\n\n.container-allocate-points-progress {\n    display: flex;\n    flex-direction: column;\n    align-items: end;\n}\n\n.allocate-points-progress-span {\n    margin-top: var(--spacing-small);\n    font-size: var(--font-medium);\n    color: var(--color-text-input-disabled);\n    font-weight: 500;\n}\n\n.container-table-allocate-points-participant {\n    margin-top: var(--spacing-regular);\n}\n\n.container-modal-focal-point-manage {\n    .ant-modal-content {\n        padding: var(--spacing-extra-big) !important;\n    }\n\n    .ant-modal-title {\n        position: absolute;\n        top: var(--spacing-regular);\n    }\n}\n\n.container-loading-upload-excel {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    background: var(--color-neutral-dark-lighter);\n    z-index: 999;\n    opacity: 0.7;\n}\n\n.icon-summary-upload-distribution {\n    width: 36px;\n    height: 36px;\n\n    span {\n        width: 100% !important;\n        height: 100% !important;\n\n        svg {\n            fill: var(--success-color) !important;\n            width: 100% !important;\n            height: 100% !important;\n        }\n    }\n}\n\n.mt-16 {\n    margin-top: 16px;\n}\n\n.modal-upload-divider {\n    width: 100%;\n    border-bottom-color: var(--color-neutral-dark-lighter);\n    border-bottom-style: solid;\n    border-bottom-width: 1px;\n}\n\n.icon-share-summary-upload-distribution {\n    span {\n        svg {\n            fill: var(--color-highlight) !important;\n        }\n    }\n}\n\n.icon-download-excel-model {\n    svg {\n        fill: white !important;\n    }\n}\n\n.form-add-participant {\n    .vert-form-item {\n        margin-bottom: 0px;\n    }\n}\n\n.modal-allocate-point-text-main {\n    font-size: var(--font-medium);\n    color: var(--color-neutral-dark-darker);\n    font-weight: 600;\n}\n\n.modal-allocate-point-text-sub {\n    font-size: var(--font-medium);\n    color: var(--color-neutral-dark-lighter);\n    font-weight: 500;\n}\n\n.modal-allocate-success-text-main {\n    font-size: var(--font-big);\n    color: var(--color-neutral-dark-darker);\n    font-weight: 600;\n}\n\n.modal-allocate-success-text-sub {\n    font-size: var(--font-medium);\n    color: var(--color-neutral-dark);\n    font-weight: 400;\n}\n\n.modal-allocate-success-container-button {\n    padding: var(--spacing-small);\n}\n\n.container-modal-excel {\n    margin-top: var(--spacing-extra-big);\n}\n\n.modal-excel-select-text {\n    font-size: var(--font-medium);\n    color: var(--color-neutral-dark);\n    font-weight: 400;\n}\n\n.modal-remove-participant-text {\n    font-size: var(--font-big);\n    color: var(--color-neutral-dark-darker);\n    font-weight: 600;\n}\n\n.modal-remove-participant-container-button {\n    margin-top: var(--font-medium);\n}\n\n.width-100 {\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
